var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconamoonSearchBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8752 21.875L17.3513 17.351M17.3513 17.351C18.1251 16.5772 18.7389 15.6585 19.1577 14.6474C19.5765 13.6363 19.7921 12.5527 19.7921 11.4583C19.7921 10.3639 19.5765 9.28027 19.1577 8.26919C18.7389 7.25812 18.1251 6.33944 17.3513 5.5656C16.5774 4.79175 15.6587 4.17791 14.6477 3.75911C13.6366 3.34031 12.5529 3.12476 11.4585 3.12476C10.3642 3.12476 9.28051 3.34031 8.26944 3.75911C7.25836 4.17791 6.33968 4.79175 5.56584 5.5656C4.003 7.12844 3.125 9.24811 3.125 11.4583C3.125 13.6685 4.003 15.7882 5.56584 17.351C7.12868 18.9139 9.24835 19.7919 11.4585 19.7919C13.6687 19.7919 15.7884 18.9139 17.3513 17.351Z",
    stroke: "#FB744C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonSearchBold);
export default __webpack_public_path__ + "static/media/iconamoon_search-bold.b77ea36daf1ec5ce10fe76029b3811ab.svg";
export { ForwardRef as ReactComponent };